module.exports = __webpack_public_path__ + "static/media/activity.32b152c5.svg";